import { render, staticRenderFns } from "./preLaudo.vue?vue&type=template&id=483950c3"
import script from "./preLaudo.vue?vue&type=script&lang=js"
export * from "./preLaudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports